export const isMobile = () => {
    let mobile = false;

    if ($(window).width() < 767)
    {
        mobile = true;
    }

    return mobile;
};

export const isTablet = (orientation) => {
    if (typeof orientation === 'undefined')
    {
        throw new Error('isTablet: No orientation defined');
    }

    let tablet = false;

    if (orientation === 'portrait' && $(window).width() > 767 && $(window).width() < 992)
    {
        tablet = true;
    }

    if (orientation === 'landscape' && $(window).width() > 992 && $(window).width() < 1224)
    {
        tablet = true;
    }

    return tablet;
};



// WEBPACK FOOTER //
// ./app/src/js/utils/device.js